import { useTranslation } from 'react-i18next'

// Accepted-card marks shown on the cart, the checkout step and the footer.
// Drawn inline as SVG rather than loaded from a CDN: the pages must keep
// working with no third-party requests, and these render crisply at any size.

function VisaMark({ className = '' }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 32" role="img" aria-label="Visa" className={className}>
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#e5e7eb" />
      <text
        x="24"
        y="21"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="13"
        fontWeight="700"
        fontStyle="italic"
        fill="#1A1F71"
        letterSpacing="0.5"
      >
        VISA
      </text>
    </svg>
  )
}

function MastercardMark({ className = '' }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 32" role="img" aria-label="Mastercard" className={className}>
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#e5e7eb" />
      <circle cx="20" cy="16" r="8" fill="#EB001B" />
      <circle cx="28" cy="16" r="8" fill="#F79E1B" />
      {/* Overlap wedge: the intersection of the two discs. */}
      <path
        d="M24 9.6a8 8 0 0 0 0 12.8 8 8 0 0 0 0-12.8Z"
        fill="#FF5F00"
      />
    </svg>
  )
}

function TroyMark({ className = '' }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 32" role="img" aria-label="Troy" className={className}>
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#e5e7eb" />
      <text
        x="24"
        y="21"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="13"
        fontWeight="700"
        fill="#00A0AF"
        letterSpacing="0.5"
      >
        troy
      </text>
    </svg>
  )
}

interface PaymentLogosProps {
  /** Tailwind height class for each mark. */
  size?: string
  className?: string
  /** Render the "secured by 3D Secure" caption under the marks. */
  withCaption?: boolean
}

export default function PaymentLogos({
  size = 'h-7',
  className = '',
  withCaption = false,
}: PaymentLogosProps) {
  const { t } = useTranslation()
  return (
    <div className={className}>
      <div className="flex items-center gap-2">
        <VisaMark className={`${size} w-auto`} />
        <MastercardMark className={`${size} w-auto`} />
        <TroyMark className={`${size} w-auto`} />
      </div>
      {withCaption && (
        <p className="mt-2 flex items-center gap-1.5 text-xs text-gray-500">
          <svg className="w-3.5 h-3.5 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
          {t('cart.secureNote')}
        </p>
      )}
    </div>
  )
}
